import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[textInputAmpersand]'
})
export class TextInputWithAmpersandDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/[-!¡$%^*()_+|~=`{}\[\]:";'<>¿¨?,.#·\/]/, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }

}
